import { useEffect, useState } from 'react';

import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { ApplicationStepNav } from '@/components/modules/Application/components/_shared/components/ApplicationStepNav';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { PaymentMethodList } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodList';
import { PaymentMethodSimulator } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodSimulator';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';

export const PaymentMethod = () => {
  const { onNext, onPrev } = useApplicationNavigation();
  const { paymentMethodEntities, createPaymentMethodEntities, isAnyPaymentMethodSelectedAndConfigured } =
    usePaymentMethods();
  const { updateCartDiscount } = useCart();

  const [firstRendered, setFirstRendered] = useState(false);

  useEffect(() => {
    createPaymentMethodEntities();
    setTimeout(() => {
      setFirstRendered(true);
    }, 700);
  }, []);

  const onSubmit = () => {
    updateCartDiscount(paymentMethodEntities);
    onNext();
  };

  const isSimulator =
    paymentMethodEntities &&
    paymentMethodEntities.length === 1 &&
    paymentMethodEntities[0] instanceof AutoLoanPaymentMethod;

  return (
    <ApplicationStepContainer>
      {isSimulator ? (
        <PaymentMethodSimulator firstRendered={firstRendered} />
      ) : (
        <PaymentMethodList firstRendered={firstRendered} />
      )}
      <ApplicationStepNav disableOnNext={!isAnyPaymentMethodSelectedAndConfigured} onNext={onSubmit} onPrev={onPrev} />
    </ApplicationStepContainer>
  );
};
